import CacheService from './CacheService.js';

// Global in-memory cache object to share data between pages and context.
export const MEMORY_CACHE = {};

// Specialized Image Cache to force "Memory Cache" (0ms latency)
// We store the actual Image objects here to prevent Garbage Collection
export const IMAGE_RAM_CACHE = {
    storage: new Map(), // URL -> Image Object
    maxSize: 100, // Increased limit for better coverage

    add: (url) => {
        if (IMAGE_RAM_CACHE.storage.has(url)) return; // Already cached
        const img = new Image();
        img.src = url;
        IMAGE_RAM_CACHE.storage.set(url, img);
        if (IMAGE_RAM_CACHE.storage.size > IMAGE_RAM_CACHE.maxSize) {
            const firstKey = IMAGE_RAM_CACHE.storage.keys().next().value;
            IMAGE_RAM_CACHE.storage.delete(firstKey);
        }
    },
    has: (url) => IMAGE_RAM_CACHE.storage.has(url),
    clear: () => IMAGE_RAM_CACHE.storage.clear()
};

// BLOB CACHE: The Ultimate 0ms Solution
// Stores explicit Blob URLs (pointers to RAM).
// Use this to bypass ANY network/disk check for images.
export const BLOB_CACHE = {
    storage: new Map(), // Original URL -> Blob URL (blob:http://...)

    get: (url) => BLOB_CACHE.storage.get(url),

    set: (url, blob) => {
        if (BLOB_CACHE.storage.has(url)) return;
        const objectUrl = URL.createObjectURL(blob);
        BLOB_CACHE.storage.set(url, objectUrl);
    },

    // Convert standard URL to Blob URL and cache it
    prefetch: async (url) => {
        if (BLOB_CACHE.storage.has(url)) return BLOB_CACHE.storage.get(url);
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);
            BLOB_CACHE.storage.set(url, objectUrl);
            return objectUrl;
        } catch (e) {
            console.error("Blob prefetch failed", e);
            return url; // Fallback
        }
    }
};

// --- INPUT CACHE (PERSISTENT) ---
// Used to pass inputs between pages (e.g. Recreate -> Feature)
// Now uses CacheService (localStorage) to ensure reliability across reloads/navigation
export const InputCache = {
    save: (slug, userId, inputData) => {
        try {
            const key = `inputs_${slug}_${userId}`;
            // Save for 30 minutes
            CacheService.set(key, inputData, 30);
        } catch (e) {
            console.error("Failed to save inputs", e);
        }
    },
    restore: (slug, userId) => {
        try {
            const key = `inputs_${slug}_${userId}`;
            const cached = CacheService.get(key);
            return cached || null;
        } catch (e) {
            return null;
        }
    },
    clear: (slug, userId) => {
        try {
            const key = `inputs_${slug}_${userId}`;
            CacheService.remove(key);
        } catch (e) { }
    }
};
